(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Rivello: baixa antes a página dos produtos visíveis para a prévia abrir rápido */
  window.rvPrefetchQuick = function (card) {
    var qa = card && card.querySelector('quick-add-component');
    if (!qa || qa.cachedProductHtml || qa._rvPrefetch || typeof qa.fetchProductPage !== 'function') return;
    qa._rvPrefetch = qa.fetchProductPage(qa.productPageUrl).catch(function () {}).finally(function () { qa._rvPrefetch = null; });
  };
  (function () {
    var queue = [], busy = 0, seen = new WeakSet();
    var pump = function () {
      while (busy < 2 && queue.length) {
        var card = queue.shift(); var qa = card.querySelector('quick-add-component');
        if (!qa || qa.cachedProductHtml || qa._rvPrefetch) continue;
        window.rvPrefetchQuick(card);
        if (!qa._rvPrefetch) continue;
        busy++;
        qa._rvPrefetch.then(function () { busy--; pump(); });
      }
    };
    var check = function () {
      var vh = window.innerHeight || 800;
      document.querySelectorAll('.rv-ver-detalhes').forEach(function (b) {
        if (seen.has(b)) return;
        var r = b.getBoundingClientRect();
        if (r.height && r.top < vh + 150 && r.bottom > -150) {
          seen.add(b); var c = b.closest('.product-card'); if (c) queue.push(c);
        }
      });
      pump();
    };
    var t = null;
    var later = function () { if (t) return; t = setTimeout(function () { t = null; check(); }, 300); };
    window.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    if (document.readyState === 'complete') setTimeout(check, 800); else window.addEventListener('load', function () { setTimeout(check, 800); });
    document.addEventListener('pointerdown', function (ev) { var b = ev.target.closest && ev.target.closest('.rv-ver-detalhes'); if (b) window.rvPrefetchQuick(b.closest('.product-card')); }, true);
    var tStart = null;
    document.addEventListener('touchstart', function (ev) { var b = ev.target.closest && ev.target.closest('.rv-ver-detalhes'); tStart = b ? { b: b, x: ev.touches[0].clientX, y: ev.touches[0].clientY } : null; }, { passive: true, capture: true });
    document.addEventListener('touchend', function (ev) {
      if (!tStart) return;
      var t = ev.changedTouches[0]; var moved = Math.abs(t.clientX - tStart.x) > 10 || Math.abs(t.clientY - tStart.y) > 10;
      var b = tStart.b; tStart = null;
      if (moved || !b.contains(ev.target)) return;
      ev.preventDefault(); ev.stopPropagation();
      window.rvVerDetalhes(b);
    }, { passive: false, capture: true });
  })();

  window.rvVerDetalhes = function (el) {
    var card = el.closest('.product-card');
    if (!card) return;
    var link = card.querySelector('a[href*="/products/"]');
    var url = link ? link.href.split('?')[0] : null;
    var btn = card.querySelector('.quick-add__button--choose');
    if (!btn) { if (url) window.location = url; return; }
    window.rvQuickUrl = url;
    var ensure = function () {
      var box = document.getElementById('quick-add-modal-content');
      if (!box || !window.rvQuickUrl) return;
      var a = box.querySelector('.rv-info-completa');
      if (a) { if (a.getAttribute('href') !== window.rvQuickUrl) a.setAttribute('href', window.rvQuickUrl); return; }
      var anchor = box.querySelector('.buy-buttons-block') || box.querySelector('product-form-component');
      if (!anchor) return;
      a = document.createElement('a');
      a.className = 'rv-info-completa';
      a.href = window.rvQuickUrl;
      a.innerHTML = 'Ver informações completas <span aria-hidden="true">&rarr;</span>';
      if (anchor.tagName === 'PRODUCT-FORM-COMPONENT') { anchor.appendChild(a); } else { anchor.insertAdjacentElement('afterend', a); }
    };
    if (!window.rvQuickObs) {
      var box = document.getElementById('quick-add-modal-content');
      if (box) {
        window.rvQuickObs = new MutationObserver(ensure);
        window.rvQuickObs.observe(box, { childList: true, subtree: true });
      }
    }
    var qa = card.querySelector('quick-add-component');
    var go = function () { btn.click(); setTimeout(ensure, 300); setTimeout(ensure, 1200); };
    if (qa && qa._rvPrefetch) { qa._rvPrefetch.then(go); } else { go(); }
  };
  } catch(e) { console.error(e); }
})();

})();
